/**
 * 路由没有生效解决方法：
 * 在App.vue中将标签换成 router-view
 */

// 导入 Vue Router 模块
import VueRouter from "vue-router";

// 定义路由配置数组
const routes = [
    // 登录界面
    {
        // 路由路径，表示根路径 '/'
        path: '/',
        // 登录--路由名称，可以用来在代码中引用这个路由
        name: 'login',
        // 异步组件加载，使用动态导入语法来懒加载组件
        component: () => import('../components/Login/Login.vue')
    },
    // 主页面，登录成功跳转过来
    {
        path: '/Index',
        name: 'index',
        component: () => import('../components/index.vue'),
        // 子路由
        children:[
            {
                path: '/userList',
                name: 'userList',
                meta:{
                    title: '用户列表'
                },
                component:()=>import('../components/userList/userList.vue')
            },
            {
                path: '/MemberVisitRecord',
                name: 'MemberVisitRecord',
                meta:{
                    title: '会员到店记录'
                },
                component:()=>import('../components/MemberVisitRecord/MemberVisitRecord.vue')
            },
            {
                path: '/WriteOffRecord',
                name: 'WriteOffRecord',
                meta:{
                    title: '会员核销记录'
                },
                component:()=>import('../components/WriteOffRecord/WriteOffRecord.vue')
            },
            {
                path: '/ProductList',
                name: 'ProductList',
                meta:{
                    title: '商品列表'
                },
                component:()=>import('../components/ProductList/ProductList.vue')
            },
            {
                path: '/ProductDetail/:id',
                name: 'ProductDetail',
                meta:{
                    title: '商品详情'
                },
                component:()=>import('../components/ProductDetail/ProductDetail.vue')
            },
            
            {
                path: '/UserDetail/:id',
                name: 'UserDetail',
                meta:{
                    title: '用户详情'
                },
                component:()=>import('../components/UserDetail/userDetail.vue')
            },
            {
                path: '/CouponList',
                name: 'CouponList',
                meta:{
                    title: '优惠券发放记录'
                },
                component:()=>import('../components/CouponList/couponList.vue')
            },
            {
                path: '/CouponDetail/:id',
                name: 'CouponDetail',
                meta:{
                    title: '优惠券详情'
                },
                component:()=>import('../components/CouponDetail/couponDetail.vue')
            },
            {
                path: '/AllCouponList',
                name: 'AllCouponList',
                meta:{
                    title: '优惠券列表'
                },
                component:()=>import('../components/AllCouponList/allCoupon.vue')
            },
            {
                path: '/QrCodeVerification',
                name: 'QrCodeVerification',
                meta:{
                    title: '二维码核销'
                },
                component:()=>import('../components/QrCodeVerification/QrCodeVerification.vue')
            },
             {
                path: '/CommodityClassification',
                name: 'CommodityClassification',
                meta:{
                    title: '商品分类'
                },
                component:()=>import('../components/CommodityClassification/CommodityClassification.vue')
            },
            {
                path: '/CommodityClassificationDetail/:id',
                name: 'CommodityClassificationDetail',
                meta:{
                    title: '商品分类'
                },
                component:()=>import('../components/CommodityClassificationDetail/CommodityClassificationDetail.vue')
            },
            {
                path: '/ParkNotice',
                name: 'ParkNotice',
                meta:{
                    title: '入园须知'
                },
                component:()=>import('../components/AgreementConfig/AgreementConfig.vue')
            },
            {
                path: '/AppointmentAgreement',
                name: 'AppointmentAgreement',
                meta:{
                    title: '预约协议'
                },
                component:()=>import('../components/AgreementConfig/AgreementConfig.vue')
            }
        ]
    }
];

// 创建 Vue Router 实例
const router = new VueRouter({
    // 设置路由模式为 history 模式，这样 URL 不会有 # 号
    mode: 'history',
    // 传递路由配置数组
    routes
});

// 避免重复路由
export function resetRouter() {
    // 重置路由匹配器（matcher）
    // 创建一个新的 VueRouter 实例，模式为 history，初始路由配置为空数组
    router.matcher = new VueRouter({
        mode: 'history', // 使用 HTML5 History 模式
        routes: [] // 初始路由配置为空数组，表示没有路由
    }).matcher; // 获取新创建的 VueRouter 实例的 matcher 并赋值给当前路由实例的 matcher
}

// 避免路由冲突解决方法之一     保存原始的 push 方法
const VueRouterPush = VueRouter.prototype.push
// 重写 VueRouter 的 push 方法
VueRouter.prototype.push = function push (to) {
    // 调用原始的 push 方法，并捕获可能抛出的错误
    return VueRouterPush.call(this, to).catch(err => err)
}

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
    // 获取token
    const token = sessionStorage.getItem('CurUser') || localStorage.getItem('CurUser')
    console.log("路由守卫触发:", to.path, "from:", from.path);
    
    // 如果是登录页面
    if (to.path === '/') {
        // 如果已经有token，重定向到主页面
        if (token) {
            // 检查是否有保存的菜单状态，如果有则跳转到该页面
            const savedActiveMenu = localStorage.getItem('vuex') ? 
                JSON.parse(localStorage.getItem('vuex')).activeMenu : null;
            const redirectPath = savedActiveMenu && savedActiveMenu !== '/userList' ? 
                savedActiveMenu : '/userList';
            console.log("重定向到:", redirectPath);
            next(redirectPath)
            return
        }
        // 没有token，允许访问登录页面
        next()
        return
    }
    
    // 如果是访问Index页面但没有指定子路由，重定向到保存的菜单状态或默认页面
    if (to.path === '/Index') {
        if (token) {
            const savedActiveMenu = localStorage.getItem('vuex') ? 
                JSON.parse(localStorage.getItem('vuex')).activeMenu : null;
            const redirectPath = savedActiveMenu && savedActiveMenu !== '/userList' ? 
                savedActiveMenu : '/userList';
            console.log("Index页面重定向到:", redirectPath);
            next(redirectPath)
            return
        }
    }
    
    // 如果没有token，重定向到登录页面
    if (!token) {
        next('/')
        return
    }
    
    // 有token，直接访问当前路由
    console.log("允许访问路由:", to.path);
    console.log("路由匹配信息:", {
        path: to.path,
        name: to.name,
        matched: to.matched.map(m => m.path)
    });
    next()
})

// 商品分类详情路由
router.addRoutes([
  {
    path: '/classification-detail/:id',
    name: 'CommodityClassificationDetail',
    component: () => import('@/components/CommodityClassificationDetail/CommodityClassificationDetail.vue'),
    meta: {
      title: '分类详情',
      requiresAuth: true
    }
  }
])

// 导出路由实例，以便在主应用中使用
export default router;